import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import type React from 'react';
import type { ProgressBarProps } from '../ProgressBar.types';

export default (ViewerComponent: React.ComponentType<ProgressBarProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent as any));
